import { render, staticRenderFns } from "./MultiselectAvatarTagNew.vue?vue&type=template&id=2a67057b&scoped=true"
import script from "./MultiselectAvatarTagNew.vue?vue&type=script&lang=ts"
export * from "./MultiselectAvatarTagNew.vue?vue&type=script&lang=ts"
import style0 from "./MultiselectAvatarTagNew.vue?vue&type=style&index=0&id=2a67057b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67057b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a67057b')) {
      api.createRecord('2a67057b', component.options)
    } else {
      api.reload('2a67057b', component.options)
    }
    module.hot.accept("./MultiselectAvatarTagNew.vue?vue&type=template&id=2a67057b&scoped=true", function () {
      api.rerender('2a67057b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/MultiselectAvatarTagNew.vue"
export default component.exports